import {
  CalendarOutlined,
  CheckCircleOutlined,
  FileOutlined,
  SafetyOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Avatar, Card, Col, Row, Space, Typography } from 'antd';
import dayjs from 'libs/dayjs';
import { useTenantData } from 'providers/Tenant/TenantDataProvider';
import React from 'react';

const { Text } = Typography;

const ClienteDashboard = ({ id }) => {
  const { clientes } = useTenantData() ?? {};
  const cliente = clientes?.find((c) => c.id === Number(id)) ?? null;

  const dayOfWeek = dayjs().format('dddd');
  const currentTime = dayjs().format('HH:mm');

  return (
    <div className="space-y-6">
      <Card className="welcome-dashboard">
        <div className="welcome-content">
          <div className="welcome-text">
            <h2 className="welcome-title">
              ¡Bienvenido{cliente?.name ? `, ${cliente.name}` : ''}!
            </h2>
            <p className="welcome-subtitle">Que tengas un excelente {dayOfWeek}</p>
            <p className="welcome-time">
              {currentTime} • {dayjs().format('DD [de] MMMM [de] YYYY')}
            </p>
          </div>
          <div className="welcome-avatar">
            <Avatar size={80} icon={<UserOutlined />} />
          </div>
        </div>
      </Card>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={8}>
          <Card title="Acceso Rápido" className="shadow-sm">
            <Space direction="vertical" className="w-full" size="middle">
              <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <ToolOutlined className="text-blue-500 text-xl" />
                  <div>
                    <Text strong>Gestionar Ascensores</Text>
                    <br />
                    <Text type="secondary" className="text-sm">
                      Ver y administrar todos los ascensores
                    </Text>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <CalendarOutlined className="text-green-500 text-xl" />
                  <div>
                    <Text strong>Programar Mantenciones</Text>
                    <br />
                    <Text type="secondary" className="text-sm">
                      Crear y gestionar mantenciones preventivas
                    </Text>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <FileOutlined className="text-orange-500 text-xl" />
                  <div>
                    <Text strong>Órdenes de Trabajo</Text>
                    <br />
                    <Text type="secondary" className="text-sm">
                      Ver y gestionar órdenes de trabajo activas
                    </Text>
                  </div>
                </div>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card title="Estado del Sistema" className="shadow-sm">
            <Space direction="vertical" className="w-full" size="middle">
              <div className="flex items-center justify-between">
                <Text>Estado General</Text>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <Text type="success">Operativo</Text>
                </div>
              </div>
              <div className="text-center py-4">
                <Text type="secondary" className="text-sm">
                  Para ver información detallada de mantenciones y órdenes de trabajo, utiliza las
                  pestañas correspondientes en el menú superior.
                </Text>
              </div>
            </Space>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card title="Nuestros Servicios" className="shadow-sm">
            <Space direction="vertical" className="w-full" size="middle">
              <div className="p-3 bg-blue-50 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <ToolOutlined className="text-blue-500" />
                  <Text strong className="text-blue-700">
                    Mantención Preventiva
                  </Text>
                </div>
                <Text type="secondary" className="text-sm">
                  Mantenimiento programado para garantizar el funcionamiento óptimo
                </Text>
              </div>
              <div className="p-3 bg-green-50 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <SafetyOutlined className="text-green-500" />
                  <Text strong className="text-green-700">
                    Emergencias 24/7
                  </Text>
                </div>
                <Text type="secondary" className="text-sm">
                  Servicio de emergencia disponible las 24 horas del día
                </Text>
              </div>
              <div className="p-3 bg-purple-50 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <CheckCircleOutlined className="text-purple-500" />
                  <Text strong className="text-purple-700">
                    Modernización
                  </Text>
                </div>
                <Text type="secondary" className="text-sm">
                  Actualización de sistemas para mejorar eficiencia y seguridad
                </Text>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ClienteDashboard;
